import { prop } from 'ramda';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGetErrorMessage } from 'js/hooks/server';
import { htcmdService } from 'js/services/htcmd.service';
import { LAYER } from 'js/components/common/PopupManager';
import { useLoginByCredentials } from 'js/hooks/auth/hooks';
import { useAuthSelector } from 'js/store/hooks';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { showReCaptchaPopupAction, hideReCaptchaPopupAction } from 'js/components/popups/ReCaptchaPopup';

export const useBiometricsHandler = () => {
    const dispatch = useDispatch();
    const loginByCredentials = useLoginByCredentials();
    const getErrorMessage = useGetErrorMessage();
    const wasAutoLoginCompleted = useAuthSelector(prop('wasAutoLoginCompleted'));

    useEffect(() => {
        window.biometricsHandler = {
            ...window.biometricsHandler,
            biometricsEnabled: (isEnabled: boolean) => htcmdService.isBiometricsEnabled(isEnabled),
            processBiometricAuthentication: (isSuccessfulRecognition: boolean, pin: string, username: string) => {
                if (!isSuccessfulRecognition) {
                    return;
                }

                loginByCredentials(username, pin)
                    .catch(function handleError(error) {
                        const data = error?.data;

                        if (data?.errorCode === 301) {
                            dispatch(showReCaptchaPopupAction({
                                operation: 'login',
                                onReCaptchaTokenValidate: () => {
                                    dispatch(hideReCaptchaPopupAction());
                                    loginByCredentials(username, pin).catch(handleError);
                                },
                                onClose: () => htcmdService.reset(),
                                onReCaptchaTokenError: () => {
                                    dispatch(hideReCaptchaPopupAction());
                                    htcmdService.reset();
                                }
                            }));

                            return;
                        }

                        if (data?.errorCode) {
                            htcmdService.reset();

                            dispatch(showCommonPopupAction({
                                title: 'playtech.mobile.system.login.error.biometricLogin',
                                content: getErrorMessage(error),
                                layer: LAYER.HIGH_PRIORITY
                            }));
                        }
                    });
            }
        };
    }, [loginByCredentials, dispatch, getErrorMessage]);

    useEffect(() => {
        if (!wasAutoLoginCompleted) {
            return;
        }

        if (htcmdService.isEnabled || htcmdService.isWrapperEnabled) {
            htcmdService.processBiometricAuthentication();
        }
    }, [
        wasAutoLoginCompleted
    ]);
};
